export default {
  headerContent: {
    title: 'Generali Sigorta Zorunlu Trafik Sigortası Teklif Al',
    slogan: "Trafik Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TRAFİK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Generali Sigorta Zorunlu Trafik Sigortası',
    description: {
      title: 'Generali Sigorta Zorunlu Trafik Sigortası Nedir? ',
      content: [
        'Zorunlu trafik sigortası trafiğe çıkan tüm motorlu taşıt sahiplerinin yaptırmak zorunda olduğu sigorta ürünüdür. Yaptırılması kanunen zorunlu olan araç sigortanızı Generali Sigorta güvencesinde yaptırarak trafikte sebep olacağınız hasarları teminat altına alabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Generali Sigorta Zorunlu Trafik Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Zorunlu trafik sigortası, trafikte oluşabilecek kazalar sonucunda 3. Kişilere verilen maddi ve bedeni hasarları ve diğer araç veya araçlarda oluşan hasarları kapsamaktadır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Trafik Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Trafik Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Trafik Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Generali Sigorta Trafik Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Generali Sigorta Zorunlu Trafik Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta ve Reasürans Şirketleri Birliği tarafından hazırlanmış olan genel şartlar gereğince;',
          subList: [
            'Maddi Zararlar',
            'Sağlık Giderleri',
            'Sürekli Sakatlık',
            'Destekten Yoksun Kalma (Ölüm) Teminatı poliçede bulunmaktadır.'
          ]
        }
      ]
    },
    {
      title:
        'Generali Sigorta Zorunlu Trafik Sigortası Teminat Dışı Kalan Haller Nelerdir?',
      content: [
        {
          paragraph: 'Aksine bir sözleşme bulunmaması durumunda;',
          subList: [
            'İşletme durumunda olmayan araçların neden olacağı zararlar',
            'Manevi tazminat talepleri',
            'Sigortalının aracında oluşan hasarlar',
            'Sigortalının kendi kusuruna denk gelen tazminat talepleri kapsam dışı sayılır.'
          ]
        }
      ]
    },
    {
      title: 'Trafik Sigortası Zamanında Yapılmazsa Ne Olur?',
      content: [
        {
          paragraph:
            'Trafik sigortasının yenilenmediği durumlarda aracın uygulamaya girmesi durumunda araç bağlanır. Bununla beraber trafik sigortası yenilenme sırasında gecikme cezası uygulanır. Bu durumlarla karşı karşıya kalmamak için zorunlu trafik sigortası poliçenizi her yıl düzenli olarak yenilemelisiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Hasar Anında İstenen Belgeler Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Kaza tespit tutanağı',
            'Alkol raporu',
            'Sigortalının ehliyet ve ruhsat fotokopisi',
            'Zarar gören aracın ruhsat ve ehliyet fotokopisi istenmektedir.'
          ]
        }
      ]
    },
    {
      title: 'Generali Sigorta Trafik Sigortası Ne Kadar?',
      content: [
        {
          paragraph:
            'Trafik sigortası primleri aracın plaka ili, hasarsızlık kademesi ve araç türüne göre değişiklik göstermektedir.',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com üzerinden başvuru formu doldurarak Generali Sigorta trafik sigortası hakkında detaylı bilgi alabilirsiniz. Uzman danışmanlarımızın sunmuş olduğu teklifi değerlendirebilir ve poliçe tanzimi yapabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigortadan Trafik Sigortasını Taksitle Alabilir Miyim?',
      content: [
        {
          paragraph:
            'Zorunlu trafik sigortasını anlaşmalı banka kredi kartınızla 6 aya kadar vadeli bir şekilde alabilirsiniz. Alokasko.com web sitesi üzerinden online trafik sigortası teklifi alabilirsiniz. ',
          subList: null
        }
      ]
    }
  ]
}
